<script setup lang="ts">
export interface SaferGamblingSubPanelProps {
    title: string
}

const props = defineProps<SaferGamblingSubPanelProps>()
</script>

<template>
    <UIExpandable class="sub-panel">
        <template #header>
            <div class="sub-panel__header">
                <UIIcon class="sub-panel__header-icon" name="plus" size="14" />
                {{ props.title }}
            </div>
        </template>

        <div class="sub-panel__content">
            <slot />
        </div>
    </UIExpandable>
</template>

<style lang="scss" scoped>
.sub-panel {
    position: relative;
    margin-bottom: 10px;
    padding-top: 10px;
    border-radius: var(--safer-gambling-panel-border-radius-sm, $safer-gambling-panel-border-radius-sm);
    text-align: left;

    &.expandable--open {
        .sub-panel__header-icon {
            transition: transform 0.2s ease-out;
            transform: rotateZ(45deg);
        }
    }

    &__header {
        color: var(--on-link, $link-color);
        display: flex;
        gap: 0.7rem;
        align-items: center;
        font-weight: 500;
    }

    :deep(.expandable__content) {
        margin-bottom: 0;
    }
}
</style>
